export const createLabelLayout = (label, { title, description, url, more_detail, link }) => {
  const href = url || link;
  const labelLink = href ? `
    <div class="product__discount_mt">
      <a class="product__discount_footer_link" href="${href}">
        ${more_detail}
        <svg class="product__register_icon" width="22" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 7h21.5m0 0L15 .5M21.5 7L15 13.5" stroke="#00502F" stroke-linejoin="round"></path>
        </svg>
      </a>
    </div>` : ''
  const labelTitle = title ? `<div class="product__discount_title">${title}</div>` : ''
  const labelDescription = description ? `<div class="product__discount_subtitle">${description}</div>` : ''
  const labelLayout = `
    <div class="prod__discount prod__label-popup-inner js_prod_bg tooltip__outer">
      <svg class="product__discount_close js_close_discount">
        <use xlink:href="#close"></use>
      </svg>
      ${labelTitle}
      ${labelDescription}
      ${labelLink}
    </div>
  `
  const sibling = label.parentElement.querySelector('.js_product_label_info');
  sibling.innerHTML = labelLayout;
}
